/**
 * OutreachTab — Stub for EXTRA_MILE stage
 * Full implementation: Sprint 9 (will fetch from /api/v2/projects/:id/outreach)
 */

interface StubTabProps {
  projectId: number
}

export function OutreachTab({ projectId }: StubTabProps) {
  return (
    <div className="py-8 text-center">
      <h3 className="text-[13px] font-medium text-[#e8e8f0] mb-2">
        Outreach & Validation
      </h3>
      <p className="text-[13px] text-[#a8a8c0] mb-4">
        Expert interviews, industry consultations, and validation events will appear here.
      </p>
      <div className="inline-block px-3 py-1.5 border border-dashed border-[#2a2a44] rounded-lg text-[12px] text-[#a8a8c0]">
        Coming in Sprint 9
      </div>
    </div>
  )
}

export default OutreachTab
